import * as Sentry from "@sentry/angular";
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from "@angular/platform-browser";

Sentry.init({
  dsn: "https://19ed605687007dda59b7241f1e222c06@o4507215801548800.ingest.de.sentry.io/4510040666800208",
  sendDefaultPii: true,
  enabled: environment.sentry.enabled,
  environment: environment.sentry.environment,
  initialScope: {
    tags: {
      whitelabel: environment.tenant
    }
  }
});

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
